export const RESET_SEARCH = '@@search/RESET_SEARCH';
export const SET_SEARCH_FILTER = '@@search/filter/SET_SEARCH_FILTER';
export const SET_SEARCH_TERM = '@@search/SET_SEARCH_TERM';
export const SET_SEARCH_SELECTION = '@@search/SET_SEARCH_SELECTION';
export const CLEAR_SEARCH_SORT_FILTERS = '@@search/CLEAR_SEARCH_SORT_FILTERS';
export const CLEAR_SEARCH_FILTER = '@@search/CLEAR_SEARCH_FILTER';
export const FETCH_SEARCH_FIELD = '@@search/FETCH_SEARCH_FIELD';
export const FETCH_SEARCH_FIELD_SUCCESS = '@@search/FETCH_SEARCH_FIELD_SUCCESS';
export const FETCH_SEARCH_FIELD_FAIL = '@@search/FETCH_SEARCH_FIELD_FAIL';
